import { render } from "./DailyReportDeviationTable.vue?vue&type=template&id=39b17ee4"
import script from "./DailyReportDeviationTable.vue?vue&type=script&lang=ts"
export * from "./DailyReportDeviationTable.vue?vue&type=script&lang=ts"

import "./DailyReportDeviationTable.vue?vue&type=style&index=0&id=39b17ee4&lang=scss"
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QTr});
